import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getImageGeneratorLibrary } from "../../app/api/imageGenerator";
import {
  GENERATIVE_PLATFORM_LIBRARY_STALE_MS,
  IMAGE_GENERATOR_LIBRARY_LIST_LIMIT,
  imageGeneratorLibraryQueryKey,
} from "./generativePlatformQueryKeys";

export const useImageGeneratorLibraryQuery = (
  limit = IMAGE_GENERATOR_LIBRARY_LIST_LIMIT,
  offset = 0
) =>
  useQuery({
    queryKey: imageGeneratorLibraryQueryKey(limit, offset),
    queryFn: async () => {
      const result = await getImageGeneratorLibrary(limit, offset);
      return result.items || [];
    },
    staleTime: GENERATIVE_PLATFORM_LIBRARY_STALE_MS,
    placeholderData: keepPreviousData,
  });
